import React, { PropTypes } from 'react';
import StyledText from 'components/Helpers/StyledText/StyledText';

const Citat = ({ value }) => {
  const style = require('./Citat.scss');
  const citat = (typeof value === 'string' && value) || (value && value.citat);
  const av = value && value.av;
  const stil = value && value.stil;
  const cstyle = value && value.cstyle ||{};
  return (
    <div className={style.wrapper}>
      <div className={(stil==='strong')?style.innerstrong:style.inner}>
        <p className={(stil==='strong')?style.citatstrong:style.citat} style={cstyle}>
          <StyledText>{citat}</StyledText>
        </p>
        {av &&
        <p className={style.av}>
          <StyledText>{av}</StyledText>
        </p>
        }
      </div>
    </div>
  );

};

Citat.propTypes = {
  children: PropTypes.string
};

export default Citat;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Citat/Citat.js
 **/